module.exports = __webpack_public_path__ + "img/om.b677118.svg";